import { useEffect } from 'react';

import type { SycurioErrorEventType } from '../types/SycurioTypes';
import { TELEPHONIC_ENTRY_ERROR_MESSAGES } from '../constants/messages';
import { getSycurioTelephonicEntryErrorMessage } from '../../../utils/session/selectors';
import type { CheckoutSessionsResponse } from '../../../services/commonCheckout/types/CheckoutSessionsResponse';

type SycurioAgentPageObserverProps = {
  hasCasiSessionFailed: boolean;
  hasSycurioIframeFailedToLoad: boolean;
  hasTimeElapseForSycurioInitMessage: boolean;
  stopSpinner: () => void;
  onError: (errorEvent: SycurioErrorEventType) => void;
  sessionResponse: CheckoutSessionsResponse;
};

export default function useSycurioAgentPageObserver({
  hasCasiSessionFailed,
  hasSycurioIframeFailedToLoad,
  hasTimeElapseForSycurioInitMessage,
  stopSpinner,
  onError,
  sessionResponse,
}: SycurioAgentPageObserverProps) {
  const errorMessage =
    getSycurioTelephonicEntryErrorMessage(sessionResponse) ??
    TELEPHONIC_ENTRY_ERROR_MESSAGES.casiError;
  useEffect(() => {
    if (
      !hasTimeElapseForSycurioInitMessage &&
      !hasCasiSessionFailed &&
      !hasSycurioIframeFailedToLoad
    ) {
      return;
    }

    if (hasCasiSessionFailed && !!errorMessage) {
      onError({
        sycurioErrorType: 'casiError',
        message: errorMessage,
      });
    }

    if (hasSycurioIframeFailedToLoad) {
      onError({
        sycurioErrorType: 'sycurioIframeError',
        message:
          TELEPHONIC_ENTRY_ERROR_MESSAGES.sycurioIframeError,
      });
    }

    stopSpinner();
  }, [
    hasCasiSessionFailed,
    hasSycurioIframeFailedToLoad,
    hasTimeElapseForSycurioInitMessage,
    errorMessage,
  ]);
}
